import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MaintenanceControl from './maintenance-control';
import MaintenanceControlDetail from './maintenance-control-detail';
import MaintenanceControlUpdate from './maintenance-control-update';
import MaintenanceControlDeleteDialog from './maintenance-control-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MaintenanceControlUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MaintenanceControlUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MaintenanceControlDetail} />
      <ErrorBoundaryRoute path={match.url} component={MaintenanceControl} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MaintenanceControlDeleteDialog} />
  </>
);

export default Routes;
